import React from 'react'
import clsx from 'clsx'
import { FaBriefcase, FaCheckCircle, FaChevronRight, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa'
import { useIntl } from 'react-intl'

import { getNotificationPresentation } from '../notifications.adapter'

const TONE_ICON = {
  success: FaCheckCircle,
  warning: FaExclamationTriangle,
  info: FaInfoCircle,
  sales: FaBriefcase,
}

export default function NotificationFeedItem({ item, onClick, variant = 'page', className }) {
  const { formatMessage: trans } = useIntl()
  const presentation = getNotificationPresentation(item)
  const ToneIcon = TONE_ICON[presentation.tone] || FaInfoCircle
  const compact = variant === 'compact'

  if (compact) {
    return (
      <button type="button" className={clsx('header-notifications-item', item.unread && 'header-notifications-item--unread', className)} onClick={() => onClick?.(item)}>
        <span className={clsx('header-notifications-item__icon', `header-notifications-item__icon--${presentation.tone || 'info'}`)}>
          <ToneIcon aria-hidden />
        </span>
        <span className="header-notifications-item__body">
          <span className="header-notifications-item__title">{item.title}</span>
          <span className="header-notifications-item__message">{item.message}</span>
          <span className="header-notifications-item__time">{item.timeLabel}</span>
        </span>
        {item.unread ? <span className="header-notifications-item__dot" aria-hidden /> : null}
      </button>
    )
  }

  return (
    <button type="button" className={clsx('notifications-feed__item', item.unread && 'notifications-feed__item--unread', className)} onClick={() => onClick?.(item)}>
      <span className={clsx('notifications-feed__icon', `notifications-feed__icon--${presentation.tone}`)}>
        <ToneIcon aria-hidden />
      </span>
      <span className="notifications-feed__main">
        <span className="notifications-feed__head">
          <strong className="notifications-feed__title">{item.title}</strong>
          {item.unread ? <span className="notifications-feed__dot" aria-hidden /> : null}
        </span>
        <p className="notifications-feed__message">{item.message}</p>
        <span className="notifications-feed__meta">
          <span>{item.timeLabel}</span>
          {presentation.actionLabel ? (
            <span className="notifications-feed__action">
              {trans({ id: presentation.actionLabelKey, defaultMessage: presentation.actionLabel })}
              <FaChevronRight aria-hidden />
            </span>
          ) : null}
        </span>
      </span>
    </button>
  )
}
